import { gql } from '@yi/core';
import { MembershipTierWithAnon } from '@yi/core/src/types/MembershipTierWithAnon';

const { Free } = gql.typesClient.MembershipTier;

const calculateHasTimeLeft = (next_assessment_at: number | string) => {
  return Date.now() < new Date(next_assessment_at).getTime();
};

export const getSubscriptionInfo = (
  subscription: gql.typesClient.Query_CurrentUserSubscription_CurrentUserSubscription | null,
  accessTier: MembershipTierWithAnon | null,
) => {
  let userMembershipPlan = subscription
    ? {
        tier: subscription.tier,
        interval:
          subscription?.tier === gql.typesClient.MembershipTier.Free
            ? null
            : subscription?.plan_interval,
      }
    : null;

  // Handle entitled users without subscriptions (e.g. iOS IAP subscriptions)
  if (accessTier !== null && accessTier !== Free && accessTier !== 'Anon') {
    if (userMembershipPlan?.tier === Free) {
      userMembershipPlan.tier = accessTier;
    } else if (!userMembershipPlan) {
      userMembershipPlan = { tier: accessTier, interval: null };
    }
  }

  const userNextMembershipPlan = subscription?.next_plan
    ? {
        tier: subscription?.next_plan?.tier,
        interval:
          subscription?.next_plan?.tier === gql.typesClient.MembershipTier.Free
            ? null
            : subscription?.next_plan?.plan_interval,
      }
    : null;

  const subStatus = subscription?.cancel_at_period_end
    ? gql.typesClient.SubscriptionStatus.CANCELLED
    : subscription?.sub_status || null;

  const hasTimeLeft = calculateHasTimeLeft(subscription?.next_assessment_at);

  const pastDue =
    subscription?.last_transaction_status === gql.typesClient.TransactionStatus.DECLINED &&
    !subscription?.cancel_at_period_end &&
    !hasTimeLeft && // @TODO check time zone considerations, this produced pastDue=true at 11pm ET of day before date string
    subscription?.sub_status === 'active';

  return { userMembershipPlan, userNextMembershipPlan, subStatus, pastDue, hasTimeLeft };
};
